import { defineRoute } from '../defineRoute';

export type LCFStartRouteParams = {
  // ...
};

export type LCFStartRouteParamsString = {
  // ...
};

export const LCFStart = defineRoute<
  LCFStartRouteParams,
  LCFStartRouteParamsString
>({
  pathname: '/create-listing',
  nlPathname: '/maken-advertentie',
  isLandlordRoute: true,
  routeParamsStringifier: () => {
    return {};
  },
  routeParamsParser: () => {
    return {};
  },
});
